import { API } from "@/lib/api";
import { GoAuraIntegrationBody, SettingsBody, SettingsReponse } from "@boxem/core-api-schema";

export function updateUserSettings(settingDto: SettingsBody) {
  return API.patch<SettingsReponse>(`/settings/${settingDto.id}`, settingDto);
}

// this function can be removed in a few months or so after launch.
// newly created users will already have a settings object... this just exists as a failsafe
export function createSettings() {
  return API.post<SettingsReponse>(`/settings`, {});
}

export function updateGoAuraIntegration(goAuraIntegration: GoAuraIntegrationBody) {
  return API.patch<GoAuraIntegrationBody>(`/settings/integrations`, goAuraIntegration);
} 

